/* eslint-disable no-throw-literal */
import { Dispatch } from "redux"
import { camelize } from "../../config/functions"
import { addSalesReturn, deleteSalesReturn, editSalesReturn, getSalesReturn, getSalesReturnByDate, getSalesReturnById, getSalesReturnWithSaleInvNoByInvDate } from "../../services/salesReturn.service"
import {
    SalesPaymentModesDropDown,
    SalesReturnActionList,
    type SalesPaymentModeTypes,
    type SalesReturnItems,
    type SalesReturnType,
} from "../../types/salesReturnTypes"

export {
    SalesPaymentModesDropDown,
    SalesReturnActionList,
    type SalesPaymentModeTypes,
    type SalesReturnItems,
    type SalesReturnType,
}

export interface AddSalesReturnAction {
    type: SalesReturnActionList.ADD_SALESRETURN
    data: SalesReturnType
}

export interface FetchSalesReturnAction {
    type: SalesReturnActionList.FETCH_SALESRETURN
    data: Array<SalesReturnType>
}

export interface UpdateSalesReturnAction {
    type: SalesReturnActionList.UPDATE_SALESRETURN
    data: SalesReturnType
    id: number
}

export interface DeleteSalesReturnAction {
    type: SalesReturnActionList.DELETE_SALESRETURN
    data: number
}

export type SalesReturnActions = AddSalesReturnAction | FetchSalesReturnAction | UpdateSalesReturnAction | DeleteSalesReturnAction

const mapSalesReturnList = (raw: unknown): SalesReturnType[] => {
    const list = Array.isArray(raw) ? raw : raw != null ? [raw] : []
    return list.map((res: any) => {
        let camelCase: any = {}
        for (let i = 0; i < Object.keys(res).length; i++) {
            const key = camelize(Object.keys(res)[i])
            const value = Object.values(res)[i]
            camelCase = { ...camelCase, [key]: value }
        }
        return camelCase as SalesReturnType
    })
}

export type SalesReturnSaveResult = {
    message: string
    data: {
        id?: number
        invoiceNumber?: string
        salesReturnEntryNumber?: string | number
    }
}

export const addSalesReturnAction = (data: SalesReturnType) => {
    // return async (dispatch: Dispatch, getState: GetState) => {

    return async (dispatch: Dispatch): Promise<SalesReturnSaveResult> => {
        return addSalesReturn(data).then(response => {
            if (response.status === 200 && response.data.data) {
                let addData = {}
                for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                    const key = camelize(Object.keys(response.data.data)[i])
                    const value = Object.values(response.data.data)[i]
                    addData = { ...addData, [key]: value }
                }
                dispatch<AddSalesReturnAction>({
                    type: SalesReturnActionList.ADD_SALESRETURN,
                    data: data
                })
                return Promise.resolve({
                    message: response.data.message
                        ? response.data.message
                        : 'Sales Return Added',
                    data: addData as SalesReturnSaveResult['data'],
                })
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to add'
                : 'Unable to add')
        })

    }
    // dispatch<AddSalesReturnAction>({
    //     type: SalesReturnActionList.ADD_SALESRETURN,
    //     data: {
    //         ...data,
    //         id: parseInt(nanoid(5))
    //     }
    // })

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Added")
    // return api().post<APIResponse<SalesReturnType>>('Sales/', data, config).then(response => {
    //     if (response.status === 200 && response.data.data) {

    //         dispatch<AddSalesReturnAction>({
    //             type: SalesReturnActionList.ADD_SALESRETURN,
    //             data: response.data.data
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Added')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to add'
    //         : 'Unable to add')
    // })
    // }
}

export const updateSalesReturnAction = (data: SalesReturnType, id: number) => {
    // return async (dispatch: Dispatch, getState: GetState) => {

    return async (dispatch: Dispatch) => {
        return editSalesReturn(data, id).then(response => {
            if (response.status === 200 && response.data.data) {
                let editData = {}
                for (let i = 0; i < Object.keys(response.data.data).length; i++) {
                    const key = camelize(Object.keys(response.data.data)[i])
                    const value = Object.values(response.data.data)[i]
                    editData = { ...editData, [key]: value }
                }
                dispatch<UpdateSalesReturnAction>({
                    type: SalesReturnActionList.UPDATE_SALESRETURN,
                    data: data,
                    id: id
                })
                return Promise.resolve(response.data.message
                    ? response.data.message
                    : 'Sales Updated')
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to update'
                : 'Unable to update')
        })

    }

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Updated")
    // return api().put<APIResponse<SalesReturnType>>(`Sales/?id=${id}`, data, config).then(response => {
    //     if (response.status === 200 && response.data.data) {
    //         dispatch<UpdateSalesReturnAction>({
    //             type: SalesReturnActionList.UPDATE_SALESRETURN,
    //             data: response.data.data
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Updated')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to update'
    //         : 'Unable to update')
    // })
}

export const fetchSalesReturnByIdAction = (id: number) => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesReturnById(id)
        return mapSalesReturnList(response.data?.data)
        // dispatch<FetchSalesReturnAction>({
        //     type: SalesReturnActionList.FETCH_SALESRETURN,
        //     data: data
        // })
    }
}

export const fetchSalesReturnAction = () => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesReturn()
        const data = mapSalesReturnList(response.data?.data)
        dispatch<FetchSalesReturnAction>({
            type: SalesReturnActionList.FETCH_SALESRETURN,
            data: data
        })
    }
}

export const fetchSalesReturnWithSaleInvByInvDateAction = (invoiceDate: string) => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesReturnWithSaleInvNoByInvDate(invoiceDate)
        const data = mapSalesReturnList(response.data?.data)
        dispatch<FetchSalesReturnAction>({
            type: SalesReturnActionList.FETCH_SALESRETURN,
            data: data
        })
    }
}


export const fetchSalesReturnByDateAction = (startDate: string, endDate: string) => {
    return async (dispatch: Dispatch) => {
        const response = await getSalesReturnByDate(startDate, endDate)
        const data = mapSalesReturnList(response.data?.data)
        dispatch<FetchSalesReturnAction>({
            type: SalesReturnActionList.FETCH_SALESRETURN,
            data: data
        })
    }
}

export const deleteSalesReturnAction = (id: number) => {
    return async (dispatch: Dispatch) => {
        return deleteSalesReturn(id).then(response => {
            if (response.status === 200) {
                dispatch<DeleteSalesReturnAction>({
                    type: SalesReturnActionList.DELETE_SALESRETURN,
                    data: id
                })
                return Promise.resolve(response.data.message
                    ? response.data.message
                    : 'Sales Deleted')
            } else {
                throw { response }
            }
        }).catch(error => {
            return Promise.reject(error.response
                ? error.response.data.message
                    ? error.response.data.message
                    : 'Unable to delete'
                : 'Unable to delete')
        })
    }
    // return async (dispatch: Dispatch, getState: GetState) => {

    // dispatch<DeleteSalesReturnAction>({
    //     type: SalesReturnActionList.DELETE_SALESRETURN,
    //     data: id
    // })

    // const token = getState().authUser.token!
    // const config = getAxiosRequestConfig(token)

    // // return Promise.resolve("Sales Deleted")
    // return api().delete<APIResponse<SalesReturnType>>(`Sales/?id=${id}`, config).then(response => {
    //     if (response.status === 200) {
    //         dispatch<DeleteSalesReturnAction>({
    //             type: SalesReturnActionList.DELETE_SALESRETURN,
    //             data: id
    //         })
    //         return Promise.resolve(response.data.message
    //             ? response.data.message
    //             : 'Sales Deleted')
    //     } else {
    //         throw { response }
    //     }
    // }).catch(error => {
    //     return Promise.reject(error.response
    //         ? error.response.data.message
    //             ? error.response.data.message
    //             : 'Unable to delete'
    //         : 'Unable to delete')
    // })
    // }
}

